import { urlBase } from "./config/index";
import axiosInstance from "../services/config/axiosinstance";

async function getFirebaseProjects({ jwt }) {
  var config = {
    method: "get",
    url: `${urlBase}/firebase-projects`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

export { getFirebaseProjects };
